import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';

export const closeModalButtonStyles = css`
  width: 30px;
  height: 30px;
  background-color: transparent;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${token('border.radius', '3px')};
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: ${token('color.interaction.hovered', colors.N0)};
  }
`;
